module.exports = "<p>\n  role-search works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/role-search/role-search.component.html
// module id = ../../../../../src/app/shared/component/role-search/role-search.component.html
// module chunks = main